module.exports = __webpack_public_path__ + "static/media/1768B1HJ.4a552760.jpg";